import { Outlet } from 'react-router-dom';
import LandingPageHeader from './Header';
import Footer from './Footer';
import ArchivedAcountSupportPopUp from '../../commonComponents/authComponents/archivedAccountSupportPopUp';


const LandingPageLayout = () => {
    return (
        <>
            <LandingPageHeader />
            <Outlet />
            <Footer />
            <ArchivedAcountSupportPopUp />

        </>

    )

}

export default LandingPageLayout;


